import Modal from 'react-bootstrap/Modal';
import {useDispatch, useSelector} from 'react-redux';
import {StoreState} from '../../type.d';
import {changeSayThanksModalState} from '../../store/actionCreators';
import handsGrip from '../../../images/hands-grip.svg';
import closeIcon from '../../../images/close-icon.svg';
import * as Styled from './SayThanksModalStyles';

const SayThanksModal = () => {
  const dispatch = useDispatch();

  const {sayThanksModal} = useSelector((rootReducer:StoreState) => rootReducer.reducer);
  
  return (
    <Styled.Container>
      <Modal 
        show={sayThanksModal}
        onHide={()=>changeSayThanksModalState()} 
        animation={false}
        centered
        size='lg'
        contentClassName='ModalContent'
        dialogClassName='ModalDialog'
      >
        <Styled.StyledModalHeader>
          <Styled.StyledModalBtn onClick={()=>dispatch(changeSayThanksModalState())} >
            <Styled.StyledImg src={closeIcon} alt='Close' />
          </Styled.StyledModalBtn>
        </Styled.StyledModalHeader>
        <Modal.Body>
          <Styled.Container className='Wrapper'>
            <Styled.Container className='LeftBlock'>            
              <Styled.StyledImg src={handsGrip} alt='Hands Phone'/>
            </Styled.Container>
            <Styled.Container className='RightBlock'>
              <Styled.StyledH2>
                Thank you!
              </Styled.StyledH2>
              <Styled.StyledParagraph>
                Thank you for sharing your thoughts. We appreciate and <br/>
                value the feedbacks from our users to deliver a better <br/>
                searching experience.
              </Styled.StyledParagraph>
            </Styled.Container>
          </Styled.Container>
        </Modal.Body>
      </Modal>
    </Styled.Container>
  );
}

export default SayThanksModal;